
import React from 'react';
import { HandsCPRTraining2026 } from '../views';

const KindergartenPage = () => {
  return <HandsCPRTraining2026/>;
};

export default KindergartenPage;
